import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spinner, Table, Button, Badge } from "react-bootstrap";

const ListSurvey = () => {
  const [loading, setLoading] = useState(true);
  const [surveyList, setSurveyList] = useState([]);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const response = await axios.get(
          "https://apidls.onegml.com/qubisa/km/participant/surveys"
        );

        setSurveyList(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching surveys:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSurveys();
  }, []);

  const handleGoToDashboard = (sid, title) => {
    const encodedTitle = encodeURIComponent(title);
    const url = `/${sid}/${encodedTitle}`;
    window.open(url, "_blank");
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("id-ID", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  return (
    <>
      {loading ? (
        <div className="text-center p-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="p-4">
          <h4 className="mb-4">List Surveys</h4>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>No</th>
                <th>SID</th>
                <th>Survey Title</th>
                <th>Start Date</th>
                <th>Expires Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {surveyList.length > 0 ? (
                surveyList.map((survey, index) => (
                  <tr key={survey.sid}>
                    <td>{index + 1}</td>
                    <td>{survey.sid}</td>
                    <td>{survey.surveyls_title?.trim()}</td>
                    <td>{formatDate(survey.startdate)}</td>
                    <td>{formatDate(survey.expires)}</td>
                    <td>
                      <Badge bg={survey.active === "Y" ? "success" : "secondary"}>
                        {survey.active === "Y" ? "Active" : "Inactive"}
                      </Badge>
                    </td>
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() =>
                          handleGoToDashboard(survey.sid, survey.surveyls_title)
                        }
                      >
                        Go to Dashboard
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Survey Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default ListSurvey;